export default "__VITE_ASSET__DF$8Tw1h__"